import { Component, AfterViewInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd, RouterModule } from '@angular/router';
import feather from 'feather-icons';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss']
})
export class App implements AfterViewInit {
  title = 'uottawa-dashboard';

  constructor(private router: Router) {}

  ngAfterViewInit(): void {
    // Render icons on startup
    feather.replace();

    // Re-render icons when navigating between pages
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        feather.replace();
      }
    });
  }
}